import { TypeOptions } from 'i18next';

/**
 * be from lark source code
 */
const basicDomainRegex = /[A-Za-z0-9.-]*[A-Za-z0-9-]/;
export const comprehensiveUrlRegex = [
  '(?:',
  '(',
  /(?:[A-Za-z][-.+A-Za-z0-9]+:(?![A-Za-z][-.+A-Za-z0-9]+:\/\/)(?!\d+\/?)(?:\/\/)?)/.source,
  basicDomainRegex.source,
  ')',
  '|',
  '(?:',
  /(?:www\.)/.source,
  basicDomainRegex.source,
  ')',
  '|',
  '(?:',
  basicDomainRegex.source,
  /\.(?:international|construction|contractors|enterprises|photography|productions|foundation|immobilien|industries|management|properties|technology|christmas|community|directory|education|equipment|institute|marketing|solutions|vacations|bargains|boutique|builders|catering|cleaning|clothing|computer|democrat|diamonds|graphics|holdings|lighting|partners|plumbing|supplies|training|ventures|academy|careers|company|cruises|domains|exposed|flights|florist|gallery|guitars|holiday|kitchen|neustar|okinawa|recipes|rentals|reviews|shiksha|singles|support|systems|agency|berlin|camera|center|coffee|condos|dating|estate|events|expert|futbol|kaufen|luxury|maison|monash|museum|nagoya|photos|repair|report|social|supply|tattoo|tienda|travel|viajes|villas|vision|voting|voyage|actor|build|cards|cheap|codes|dance|email|glass|house|mango|ninja|parts|photo|shoes|solar|today|tokyo|tools|watch|works|aero|arpa|asia|best|bike|blue|buzz|camp|club|cool|coop|farm|fish|gift|guru|info|jobs|kiwi|kred|land|limo|link|menu|mobi|moda|name|pics|pink|post|qpon|rich|ruhr|sexy|tips|vote|voto|wang|wien|wiki|zone|bar|bid|biz|cab|cat|ceo|com|edu|gov|int|kim|mil|net|onl|org|pro|pub|red|tel|uno|wed|xxx|xyz|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)\b/
    .source,
  ')',
  ')',
  '(?:' + /[-A-Za-z0-9+&@#\\/%=~_()|'$*[\]?!:,.;]*[-A-Za-z0-9+&@#/%=~_()|'$*[\]]/.source + ')?',
].join('');

export class UrlProcessor {
  private _url: string;
  private _protocolMatched: string;
  public protocolPrepended: boolean = false; // 直接在类内部声明，并初始化为 false

  constructor(url: string, protocolMatched: string) {
    this._url = url;
    this._protocolMatched = protocolMatched;
  }

  getUrl(): string {
    let url = this._url;
    if (!this._protocolMatched && !this.protocolPrepended) {
      url = 'http://' + url;
      this.protocolPrepended = true; // 标记协议已添加
    }
    return url;
  }

  getAnchorHref(): string {
    return this.getUrl().replace(/&amp;/g, '&');
  }

  getAnchorText(): string {
    return this._url;
  }
}

type ObjectOrNever = TypeOptions['allowObjectInHTMLChildren'] extends true ? Record<string, unknown> : never;
type ReactI18NextChildren = React.ReactNode | ObjectOrNever;
export const checkObjectType = (value: ReactI18NextChildren | Iterable<ReactI18NextChildren>) => {
  if (!value || value === null) {
    return 'null';
  }
  const baseType = typeof value;
  if (!['object', 'function'].includes(baseType)) {
    return baseType;
  }
  if (baseType === 'function' && Function.prototype.toString.call(value).startsWith('class')) {
    return 'class';
  }
  const className = value.constructor.name;
  if (typeof className === 'string' && className !== '') {
    return className;
  }
  return baseType;
};
